<div id="pdf-content">
  <div
    class="card"
    [ngStyle]="{
      'background-image': 'url(' + userCardAssets?.cardBackground + ')'
    }"
  >
    <div class="first-row">
      <div class="card-content">
        <div class="name">{{ cardInfo?.name }}</div>
        <div class="student-grade" *ngIf="cardInfo?.gradeName">
          {{ cardInfo?.profile | uppercase }}
          | {{ cardInfo?.gradeName }}
        </div>
      </div>
      <div class="qr-code qr-code-high-contrast">
        <img [src]="cardInfo?.qrCode" alt="qrCode" />
      </div>
    </div>
    <div class="second-row">
      <div class="login">login: {{ cardInfo?.login }}</div>
    </div>
    <div class="third-row">
      <div class="logo">
        <img
          [src]="userCardAssets?.logoCard"
          alt="lex-logo"
          class="header-logo-template"
        />
      </div>
      <div class="images" *ngIf="cardInfo?.imgsCard">
        <div
          *ngFor="let img of cardInfo?.imgsCard"
          style="
            display: inline-block;
            border-radius: 6px;
            background-color: #fff;
            gap: 4px;
          "
        >
          <img
            [src]="img"
            style="padding: 2px"
            width="29px"
            height="27px"
            alt="Image"
          />
        </div>
      </div>
    </div>
  </div>
</div>
